<template>
  <SAIIconBtn
    icon="eva-arrow-back"
    color="grey-8"
    :class="{ 'q-mr-md': spaced }"
    size="12px"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import { SAIIconBtn } from 'ecx.saigon.ui.common';

export default {
  name: 'HeaderBackBtn',
  props: {
    spaced: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SAIIconBtn
  }
};
</script>
